/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1TutoraiDocumentsDocumentidMutationResponse,
  DeleteApiV1TutoraiDocumentsDocumentidPathParams,
  DeleteApiV1TutoraiDocumentsDocumentid401,
  DeleteApiV1TutoraiDocumentsDocumentid404,
  DeleteApiV1TutoraiDocumentsDocumentid500,
} from "../../types/tutorAIDocumentosController/DeleteApiV1TutoraiDocumentsDocumentid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1TutoraiDocumentsDocumentid } from "../../clients/tutorAIDocumentosController/deleteApiV1TutoraiDocumentsDocumentid.ts";

export const deleteApiV1TutoraiDocumentsDocumentidMutationKey = () =>
  [{ url: "/api/v1/tutorai/documents/:documentId" }] as const;

export type DeleteApiV1TutoraiDocumentsDocumentidMutationKey = ReturnType<
  typeof deleteApiV1TutoraiDocumentsDocumentidMutationKey
>;

export function deleteApiV1TutoraiDocumentsDocumentidMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = deleteApiV1TutoraiDocumentsDocumentidMutationKey();
  return mutationOptions<
    DeleteApiV1TutoraiDocumentsDocumentidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1TutoraiDocumentsDocumentid401
      | DeleteApiV1TutoraiDocumentsDocumentid404
      | DeleteApiV1TutoraiDocumentsDocumentid500
    >,
    {
      documentId: DeleteApiV1TutoraiDocumentsDocumentidPathParams["documentId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ documentId }) => {
      return deleteApiV1TutoraiDocumentsDocumentid(documentId, config);
    },
  });
}

/**
 * @description Remove o documento por completo: arquivo no storage, embeddings e registro. Operação irreversível. **(Requer Authorization para autenticação)**
 * @summary Deletar documento (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/documents/:documentId}
 */
export function useDeleteApiV1TutoraiDocumentsDocumentid<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1TutoraiDocumentsDocumentidMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1TutoraiDocumentsDocumentid401
        | DeleteApiV1TutoraiDocumentsDocumentid404
        | DeleteApiV1TutoraiDocumentsDocumentid500
      >,
      {
        documentId: DeleteApiV1TutoraiDocumentsDocumentidPathParams["documentId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiV1TutoraiDocumentsDocumentidMutationKey();

  const baseOptions = deleteApiV1TutoraiDocumentsDocumentidMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1TutoraiDocumentsDocumentidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1TutoraiDocumentsDocumentid401
      | DeleteApiV1TutoraiDocumentsDocumentid404
      | DeleteApiV1TutoraiDocumentsDocumentid500
    >,
    {
      documentId: DeleteApiV1TutoraiDocumentsDocumentidPathParams["documentId"];
    },
    TContext
  >;

  return useMutation<
    DeleteApiV1TutoraiDocumentsDocumentidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1TutoraiDocumentsDocumentid401
      | DeleteApiV1TutoraiDocumentsDocumentid404
      | DeleteApiV1TutoraiDocumentsDocumentid500
    >,
    {
      documentId: DeleteApiV1TutoraiDocumentsDocumentidPathParams["documentId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1TutoraiDocumentsDocumentidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1TutoraiDocumentsDocumentid401
      | DeleteApiV1TutoraiDocumentsDocumentid404
      | DeleteApiV1TutoraiDocumentsDocumentid500
    >,
    {
      documentId: DeleteApiV1TutoraiDocumentsDocumentidPathParams["documentId"];
    },
    TContext
  >;
}
